import type { AuthErrorKeyMap } from '../../../types/auth';

export const otpAuthErrorConfig: AuthErrorKeyMap = {
    key: 'otp',
    value: {
        403: {
            otp_expired: 'errors.frontend.otp.invalidOrExpired',
        },
        // GoTrue returns 422/otp_disabled for a phone with no existing account, not a 404-style code.
        422: {
            otp_disabled: 'errors.frontend.otp.accountNotFound',
        },
        default: 'errors.frontend.otp.invalidOrExpired',
    },
};
